"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultIconProps = exports.IconSvgWrapper = exports.EmptyIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _theme = require("./theme");
var _constants = require("../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var defaultIconProps = {
  color: _theme.IconTheme["default"].color
};
exports.defaultIconProps = defaultIconProps;
var SIZE_MAP = {
  xs: '1rem',
  sm: '1.25rem',
  md: '1.5rem',
  lg: '3rem',
  xl: '4rem'
};
var IconSvgWrapper = function IconSvgWrapper(props) {
  var children = props.children,
    ariaHidden = props.ariaHidden,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    title = props.title;
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    className: "seedling-birch-icon",
    fill: "none",
    height: SIZE_MAP[size],
    width: SIZE_MAP[size],
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": ariaHidden
  }, (0, _constants.getDataProvidesProps)(props)), title && /*#__PURE__*/React.createElement("title", null, title), children);
};
exports.IconSvgWrapper = IconSvgWrapper;
IconSvgWrapper.defaultProps = {
  'data-provides': 'icon'
};

// This Icon is only used for Storybook to be able to autogenerate the ArgTypes based on the component
var EmptyIcon = function EmptyIcon(_) {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
exports.EmptyIcon = EmptyIcon;